let dt_index = null;
let dt_subcategory = null;
let microsite_id = null;


export function index(params){

    dt_index = $('#categories_table').DataTable({
        ajax: {
            url: $('#categories_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_categories_actions },
            { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_categories_visible},
            { width: '50', data: 'order', class: 'text-right', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [3, 'asc'],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_categories"]').click(batch_delete_categories);
    });

    // dt_index.on('draw', function(e, settings){
    //     $(settings.nTableWrapper).find('.update_active').click(update_active);
    // });

    microsite_id = params.microsite_id;
}

function render_categories_actions(data, type, row){

    const url_info = ($("#categories_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

function render_categories_visible(data, type, row){

    let visibility = '<div class="btn-group" role="group">';

    switch (row.visible) {

        case 'hidden':
            visibility +='   <button class="btn btn-default btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-eye-slash"></i></button>';
            break;

        case 'visible':    
            visibility +='   <button class="btn btn-primary btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-eye"></i></button>';
            break;

        case 'only_guest':
            visibility +='   <button class="btn btn-secondary btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user-secret"></i></button>';
            break;

        case 'only_users':
            visibility +='   <button class="btn btn-info btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user"></i></button>';
            break;

        case 'only_health':
            visibility +='   <button class="btn btn-success btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user-doctor"></i></button>';
            break;
            
    }
                
    visibility += '</div>';

    return visibility;
}

export function show(params){
    microsite_id = params.microsite_id;
    // datatable subcategories
    
    dt_subcategory = $('#subcategories_table').DataTable({
        ajax: {
            url: $('#subcategories_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        autoWidth: false,
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_subcategories_actions },
            { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_categories_visible},
            { width: '50', data: 'order', class: 'text-right', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [[3, 'asc']],
    });

    dt_subcategory.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_categories"]').click(batch_delete_categories);
    });

    // dt_subcategory.on('draw', function(e, settings){
    // });
}

function render_subcategories_actions(data, type, row){

    const url = ($("#subcategories_table").attr('url'));

    const url_info = ($("#subcategories_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

export function index_reload(){
    
    if(dt_index != null){
        dt_index.ajax.reload();
    }
    if(dt_subcategory != null){
        dt_subcategory.ajax.reload();
    }
}

export function index_force_reload(){
    if(dt_index != null){
        dt_index.column(0).checkboxes.deselectAll();
        dt_index.ajax.reload();
    }
    if(dt_subcategory != null){
        dt_subcategory.column(0).checkboxes.deselectAll();
        dt_subcategory.ajax.reload();
    }
}

function batch_delete_categories(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.categories.batch_delete'].replace('{microsite}', microsite_id);
    
    let categories_id = [];
    $.each(rows_selected, function(index, rowId){
        categories_id.push(rowId);
    });
    
    if(categories_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna categoría'));

    } else {

        const title = __('Eliminar categorías');
        const text = 
            trans_choice('{1} Estás a punto de eliminar una categoría.|[2,*] Estás a punto de eliminar :count categorías.', categories_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let category_id of categories_id){
                        formData.append('categories_id[]', category_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

    

}